module.exports = __webpack_public_path__ + "img/img7.3b855d98.png";